import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ImageStylePage = loadAsyncComponent(() => import('./Container'), 'page');
